import React, { FC } from 'react'
import { Button } from '@microservices/wiskey-react-components'
import { Box, Typography } from '@mui/material'

import { selectTimelineSelectionCounts } from '@redux/reducers/timeLine.reducer'

import { useAppSelector } from '@hooks'
import { buttonStylesByMode } from '@helpers'

type Props = {
  onClearSelectedCells: () => void
}

export const SelectedCellsCount: FC<Props> = props => {
  const { onClearSelectedCells: handleClearSelectedCells } = props

  const { selectedCellsCount, selectedEventsCount } = useAppSelector(selectTimelineSelectionCounts)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 1,
        visibility: selectedCellsCount > 0 ? 'visible' : 'hidden',
      }}
    >
      <Typography fontSize='0.75rem'>
        Selected Cells: {selectedCellsCount} | Selected Events: {selectedEventsCount}
      </Typography>
      <Button
        sx={theme => buttonStylesByMode(theme, true)}
        variant='text'
        onClick={handleClearSelectedCells}
      >
        reset selected items
      </Button>
    </Box>
  )
}
